import type { FaireProductEntity } from "../../entity_types/product";

export const p_k9zx9xg5qm: FaireProductEntity = {
  token: "p_k9zx9xg5qm",
  type: "product",
  name: "Alpaca Zip Front Jacket - (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/2722939128b5739157a7fed70eabaca4db2debd93512cde7b6956840886dccb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7d7fe14695304f0ba28e4c23f2e8ba07c296121079dd6b3373dd0b6333cb550.jpeg",
    "https://cdn.faire.com/fastly/e07ce1b7f8be36b5bbfbde7890968ded2322bf95cb52e3dfe0d0fd2f79e2451f.jpeg",
    "https://cdn.faire.com/fastly/2c1874d0df30294f5d13cbbace4e182c5e3724ba77000102ce1950f886e28e63.jpeg",
    "https://cdn.faire.com/fastly/913815eff1921c68da071d19188c485f8226c8e4d6b86bbef8456f61d005f58b.jpeg",
    "https://cdn.faire.com/fastly/eafb55eb517f1091f038ccb8a387eea0d971bda31df2f2c5850a6097e57376af.jpeg",
    "https://cdn.faire.com/fastly/7324f44a8fe2af2c736f2a2905fb2365e4a8e222edc0cb1a0777a20439e33e49.jpeg",
    "https://cdn.faire.com/fastly/79c2ab2c44075363355803eeb41a8498a6c2b5f00032e8b0a4aae1b414f184d1.jpeg",
    "https://cdn.faire.com/fastly/23e73eeb69fbe1c7c0c6868c946e3c9f848fb1bb296ac3a13363fef1d2ddba1b.jpeg",
    "https://cdn.faire.com/fastly/769110efdd50d8979d484a96a692503495b0bd42823b25bf400ffec80f186936.jpeg",
    "https://cdn.faire.com/fastly/98344d2e222aefa9351beca44e71e042757f6e14ebf97ba920ceb2b26208be04.jpeg",
    "https://cdn.faire.com/fastly/86cc90f72cf522ca9bebbc3bd594460b7bc15fc69d67d2c7e756d53e6ce1d7d5.jpeg",
    "https://cdn.faire.com/fastly/405a8cc0f914fd294ecba5f8bb7beb13b250f9c0f29e54b389633551b3e3abcb.jpeg",
    "https://cdn.faire.com/fastly/a9d63705c8d4db3e427730b9a60da82525002ebee45a1e575ff5e2101e47fe13.jpeg",
  ],
  priceDollars: 380,
  description:
    '𝐖𝐡𝐲 𝐰𝐞 𝐦𝐚𝐝𝐞 𝐭𝐡𝐢𝐬?\n\nAn elevated spin on the classic cozy sweater, the Alpaca Zip Front Jacket is crafted from a soft wool blend with a luxe hand feel. Designed with a mock neck, front pockets, and an easy zip closure, it’s the perfect layer for both relaxed days and more polished looks.\n\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n32% Alpaca 25% Yak Wool 22% Lambs Wool 21% Poly\n\nMade in China\n\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\nDry Clean Only\n\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\nXS/S - Length: 21", Chest: 23"\n\nM/L - Length: 22", Chest: 24"\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S\n\n\nMSRP: $195 USD',
  tags: [],
  msrpDollars: 780,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:04.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
